module.exports = __webpack_public_path__ + "static/media/session1.864c4726.svg";